import React from 'react';
import { CheckCircle, Award, Users, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-6">
              <span className="text-gradient-gold">EMRE TİCARET</span> Hakkında
            </h1>
            <p className="text-xl text-gray-300 text-center mb-12">
              İzmir'de Su Kaçağı Tespiti ve Tesisat Hizmetlerinde Güvenilir Ortağınız
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="space-y-6">
              <div className="h-96 rounded-2xl overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/dlx3iiwn_IMG-20251113-WA0016.jpg" 
                  alt="EMRE TİCARET - Profesyonel Banyo Tadilatı"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-white mb-4">Kimiz?</h2>
              <p className="text-gray-300 leading-relaxed">
                EMRE TİCARET olarak, İzmir'de yıllardır su kaçağı tespiti, sıhhi tesisat ve tadilat hizmetleri sunuyoruz. 
                Bayraklı merkezli olarak faaliyet gösteren firmamız, tüm İzmir ilçelerine hizmet vermektedir.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Serkan ve Emre Gürpınar'ın kurduğu firmamız, profesyonel ekipmanları ve deneyimli kadrosuyla 
                sektörde fark yaratmaktadır. En son teknoloji cihazlarla kırmadan su kaçağı tespiti yaparak, 
                müşterilerimize zaman ve maliyet tasarrufu sağlıyoruz.
              </p>
              <p className="text-gray-300 leading-relaxed">
                İzmir'de su kaçağı tespiti ve sıhhi tesisat denince akla gelen ilk isimlerden biri olmayı başardık. 
                Bayraklı'da banyodan mutfağa, komple daire tadilatına kadar her aşamada yanınızdayız.
              </p>
              <div className="pt-6">
                <h3 className="text-xl font-bold text-yellow-500 mb-4">Temel Değerlerimiz</h3>
                <ul className="space-y-3">
                  {[
                    'Müşteri memnuniyeti odaklı hizmet',
                    'Kaliteli malzeme ve işçilik garantisi',
                    'Şeffaf fiyatlandırma politikası',
                    'Hızlı ve güvenilir çözümler',
                    'Profesyonel ve deneyimli ekip'
                  ].map((value, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <CheckCircle className="w-5 h-5 text-yellow-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-300">{value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {[
              {
                icon: Award,
                title: 'Uzmanlık',
                description: 'Yılların deneyimi ve profesyonel ekip'
              },
              {
                icon: Users,
                title: 'Binlerce Müşteri',
                description: 'İzmir genelinde memnun müşteri kitlesi'
              },
              {
                icon: Clock,
                title: '7/24 Destek',
                description: 'Acil durumlar için her zaman ulaşılabilir'
              }
            ].map((item, index) => (
              <Card key={index} className="bg-zinc-900 border-zinc-800 text-center">
                <CardContent className="pt-8 space-y-4">
                  <div className="w-16 h-16 mx-auto bg-yellow-500/10 rounded-full flex items-center justify-center border-2 border-yellow-500/30">
                    <item.icon className="w-8 h-8 text-yellow-500" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{item.title}</h3>
                  <p className="text-gray-400">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="bg-gradient-to-r from-zinc-900 via-zinc-900/50 to-zinc-900 rounded-2xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-center text-gradient-gold mb-6">
              Hizmet Alanımız
            </h2>
            <p className="text-gray-300 text-center max-w-3xl mx-auto mb-8">
              Bayraklı merkez olmak üzere, Konak, Karşıyaka, Bornova, Buca, Balçova, Çiğli, Gaziemir, Narlıdere, 
              Güzely alı, Mende ve tüm İzmir ilçelerine hizmet veriyoruz. İzmir'in her noktasında profesyonel 
              tesisat ve tadilat çözümleri için yanınızdayız.
            </p>
            <div className="flex justify-center">
              <div className="inline-block px-6 py-3 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
                <p className="text-yellow-500 font-semibold text-lg">
                  266 Sk. No:49/A Bayraklı – İZMİR (Özkanlar Pazaryeri İçi)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
